export default function useCopyObject(object) {
  if (object == undefined) {
    return null;
  } else {
    let copy = JSON.parse(JSON.stringify(object));
    return copy;
  }
}
